// extracted by mini-css-extract-plugin
module.exports = {"mainPay":"PayResult_mainPay__3a5C1","bodyTitle":"PayResult_bodyTitle__3Hjb-","bodyNumber":"PayResult_bodyNumber__3froH"};